<div *ngIf="uploadSetting && showFileType" class="col-4" style="padding: 0.375rem 0.75rem; text-align: left;">{{ label.uploadType }}<span class="extention">{{uploadSetting.type}}</span></div>
<div class="qq-uploader-selector qq-uploader qq-gallery" attr.qq-drop-area-text="{{ label.dropAreaText }}" [style.cursor]="disabled? 'not-allowed':''">
  <input type="file" class="sr-only" [id]="name"  [multiple]="!single" (change)="fileInputOnChange($event)" #fileInput>
  <ul class="qq-upload-list" [class.deny]="disabled" *ngIf="uploadSetting">
    <li class="col-md-6 col-sm-6" *ngFor="let file of files" (click)="stopPropagation($event)">
      <ng-container *ngIf="file.thumbnailUrl; else fileTmp">
        <a target="_blank" href="{{file.thumbnailUrl}}">
          <ng-container *ngTemplateOutlet="fileTmp"></ng-container>
        </a>
      </ng-container>
      <ng-template #fileTmp>
        <div class="qq-file-name">
          <span class="qq-upload-file" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" title="{{file.name}}">{{file.name}}</span>
        </div>
        <!-- <br><span class="qq-upload-size">{{ file.size | fileSize }}</span> -->
        <div *ngIf="file && !file.fileid && file.progress && file.progress > 0" class="progress form-group">
          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="file.progress"></div>
        </div>
        <button *ngIf="file.fileid" type="button" class="qq-btn qq-upload-delete" (click)="deleteFile($event, file)">
          <span aria-label="Delete" class="fa fa-trash"></span>
        </button>
      </ng-template>
    </li>
  </ul>
  <ngx-loading [show]="loading"></ngx-loading>
</div>
